import React from 'react';
import { Images } from '@/assets/images';
import { getContentType } from '@/lib/utils/getURIType.util';
import AudioContainer from './AudioContainer';
import NFTImageContainer from './NFTImageContainer';
import PDFContainer from './PDFContainer';
import VideoContainer from './VideoContainer';
import { useQuery } from '@tanstack/react-query';

interface RenderNFTItemProps {
  item: string;
  onClick?: () => void | undefined | null;
  imageUrl?: string;
  isSuccessScreen?: boolean;
}

const RenderNFTItem: React.FC<RenderNFTItemProps> = ({ item, onClick, imageUrl, isSuccessScreen }) => {
  const { data: contentType, isLoading } = useQuery({
    queryKey: ['nft_media', { item }],
    queryFn: async () => {
      if (item) {
        const response = await getContentType(item);

        return response || null;
      }

      return null;
    },
    enabled: !!item
  });

  if (isLoading) return;

  if (!contentType) {
    return (
      <NFTImageContainer imageUrl={item || Images.CARD_IMG} onClick={onClick} previewImgUrl={Images.PREVIEW_IMAGE} />
    );
  }

  if (contentType.includes('mp4')) {
    return <VideoContainer videoUrl={item || ''} />;
  }
  if (contentType.includes('pdf')) {
    return <PDFContainer url={imageUrl || ''} downloadUrl={item || ''} />;
  }
  if (contentType.includes('mp3') || contentType.includes('audio') || contentType.includes('mpeg')) {
    return <AudioContainer audioUrl={item || ''} imageUrl={imageUrl || ''} isSuccessScreen={isSuccessScreen} />;
  }
  return (
    <NFTImageContainer imageUrl={item || Images.CARD_IMG} onClick={onClick} previewImgUrl={Images.PREVIEW_IMAGE} />
  );
};

export default RenderNFTItem;
